const EN_DASH = '–'

export const formatToponym = (value: string): string =>
  value.replace(/(\S)--(\S)/g, `$1${EN_DASH}$2`)
